<!-- Mobile Grid -->
<ul class="d-lg-none mobile-grid">
    <li class="item" *ngFor="let request of requests"
        [class.action-required]="request.RequestItem.ActionRequired === true">
        <div class="status-indicator">
            <!-- <user-request-status-indicator [statusId]="request.UserStatus"></user-request-status-indicator> -->
        </div>
        <div class="row">
            <div class="offset-2 col-10 offset-sm-1 col-sm-11">
                <a *ngIf="canViewRequestManagement && !isUser && request.RequestItem.CanView" href="" (click)="goToRequest(request.RequestItem.RequestID); $event.preventDefault()" [attr.aria-label]="'Open details for ' + request.RequestItem.Title">{{ request.RequestItem.Title }}</a>
                <span *ngIf="!canViewRequestManagement || isUser || !request.RequestItem.CanView">{{ request.RequestItem.Title }}</span>
            </div>
        </div>
        <div class="row" *ngIf="request.RequestItem.IsFlex">
            <div class="offset-2 col-10 offset-sm-1 col-sm-11">
                <label>Flex:</label> <span class="badge bg-dark cpl-pill-border cpl-border-dark">
                    <i class="far fa-clock" aria-hidden="true"></i>
                </span>
            </div>
        </div>
        <div class="row" *ngIf="portalSettings.Act48Enabled && request.RequestItem.IsAct48">
            <div class="offset-2 col-10 offset-sm-1 col-sm-11">
                <label>Act 48:</label>
                <a48-icon [item]="{ IsAct48: request.RequestItem.IsAct48 }"></a48-icon>                
            </div>
        </div>
        <div class="row">
            <div class="offset-2 col-10 offset-sm-1 col-sm-11">
                <label>Availability:</label> <span>{{ request.RequestItem.AvailabilityDisplay }}</span>
            </div>
        </div>
        <div class="row">
            <div class="offset-2 col-10 offset-sm-1 col-sm-11">
                <label>Submission Limit:</label> <span>{{ getUserRequestLimit(request) }}</span>
            </div>
        </div>
        <div class="row">
            <div class="offset-2 col-10 offset-sm-1 col-sm-11">
                <label>Submission Status:</label>
                <div class="mt-1">
                    <edl-status-aggregation-indicator
                        [userStatusCounts]="request.StatusCounts"
                        [activeColumns]="activeStatusColumns">
                    </edl-status-aggregation-indicator>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="offset-2 col-10 offset-sm-1 col-sm-11">
                <label>Last Updated:</label> <span>{{ request.LastUpdatedDate | dateExtended: 'MM/dd/yyyy' }}</span>
            </div>
        </div>
        <button 
            *ngIf="isUser || canViewRequestManagement"
            class="btn btn-info form-control mobile-button"
            (click)="viewSubmissions(request)"
            type="button"
            [attr.aria-label]="'View submissions for ' + request.RequestItem.Title">
            View Submissions
        </button>
    </li>
</ul>

<!-- Desktop Grid -->
<table class="table table-striped expandable-rows d-none d-lg-block">
    <thead>
    <tr>
        <th scope="col"><sort-by label="Request Name" field="title"></sort-by></th>
        <th scope="col" class="fit">Flex</th>
        <th scope="col" class="fit" *ngIf="portalSettings.Act48Enabled">Act 48</th>
        <th scope="col" class="fit">Availability</th>
        <th scope="col" class="fit">Submission Limit</th>
        <th scope="col" class="fit text-center">Submission Status</th>
        <th scope="col" class="fit"><sort-by label="Last Updated" field="lastUpdated"></sort-by></th>
        <th scope="col" class="fit"></th>
    </tr>
    </thead>
    <tbody>
    <tr *ngFor="let request of requests">
        <td>
            <a *ngIf="canViewRequestManagement && !isUser && request.RequestItem.CanView" href="" class="word-wrap" (click)="goToRequest(request.RequestItem.RequestID); $event.preventDefault()" [attr.aria-label]="'Open details for ' + request.RequestItem.Title">{{ request.RequestItem.Title }}</a>
            <span *ngIf="!canViewRequestManagement || isUser || !request.RequestItem.CanView">{{ request.RequestItem.Title }}</span>
        </td>
        <td class="text-start fit">
            <i *ngIf="request.RequestItem.IsFlex" class="far fa-clock" aria-hidden="true"></i>
        </td>
        <td class="text-start fit" *ngIf="portalSettings.Act48Enabled">
            <a48-icon [item]="{ IsAct48: request.RequestItem.IsAct48 }"></a48-icon>
        </td>
        <td class="text-center">
            {{ request.RequestItem.AvailabilityDisplay }}
        </td>
        <td class="text-center">
            {{ getUserRequestLimit(request) }}
        </td>
        <td class="text-center">
            <edl-status-aggregation-indicator
                [userStatusCounts]="request.StatusCounts"
                [activeColumns]="activeStatusColumns">
            </edl-status-aggregation-indicator>
        </td>
        <td class="text-center">
            {{ request.LastUpdatedDate | dateExtended: 'MM/dd/yyyy' }}
        </td>
        <td class="fit">
            <button 
                *ngIf="isUser || canViewRequestManagement"
                class="btn btn-info"
                (click)="viewSubmissions(request)"
                type="button"
                [attr.aria-label]="'View submissions for ' + request.RequestItem.Title">
                View Submissions
            </button>
        </td>
    </tr>
    </tbody>
</table>

<div class="content" *ngIf="requests.length === 0">
    <p>No results found.</p>
</div>